import { render, staticRenderFns } from "./addproduct.vue?vue&type=template&id=74dfff7e&"
import script from "./addproduct.vue?vue&type=script&lang=js&"
export * from "./addproduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74dfff7e')) {
      api.createRecord('74dfff7e', component.options)
    } else {
      api.reload('74dfff7e', component.options)
    }
    module.hot.accept("./addproduct.vue?vue&type=template&id=74dfff7e&", function () {
      api.rerender('74dfff7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rawmaterials/AddProduct/addproduct.vue"
export default component.exports